import $ from 'jquery';

class Header {
    constructor(header) {
        this.$header = $(header);
        this.$icons = this.$header.find('.pi-icon--menu, .pi-icon--close');

        this.events();
    }

    onClick() {
        this.$header.toggleClass('pi-header--is-menu-open');
        this.$icons.toggleClass('pi--is-hidden');
    }

    events() {
        this.$header.on('click', '.pi-header__toggle', () => {
            this.onClick();
        });
    }
}

const init = () => {
    for(const header of $('.pi-header')) {
        new Header(header);
    }
};

export default {
    init
};



// WEBPACK FOOTER //
// ./src/scripts/blocks/header.js